export default {
  nav: {
    home: "Home",
    aboutUs: "About Us",
    products: "Products",
    quality: "Quality",
    sustainability: "Sustainability",
    globalReach: "Global Reach",
    contact: "Contact",
  },
  quick: {
    whatsapp: "WhatsApp",
    zalo: "Zalo",
    wechat: "WeChat",
    qrTitle: "Connect with us on {{app}}",
    qrDesc:
      "Scan the QR code below with {{app}} to chat directly with our export team.",
    qrPlaceholder: "{{app}} QR code",
    qrStepsTitle: "How to scan",
    qrStep1: "Open {{app}} on your phone and go to the scan screen.",
    qrStep2: "Point your camera at the code below to open our profile.",
    qrStep3: "Send us a message — our team replies within one business day.",
    qrClose: "Close",
    callNow: "Call Now",
    callTitle: "Call our export team",
    callDesc:
      "Reach our export desk directly — we are happy to help during business hours.",
    callLabel: "Phone number",
    callCopy: "Copy number",
    callCopied: "Copied",
    callClose: "Close",
    open: "Open quick contact",
    close: "Close quick contact",
  },
  footer: {
    heading: "Let’s Grow\na Brighter Future Together",
    cta: "Get in Touch",
    rights: "© 2026 EverRice. All rights reserved.",
    email: "info@everrice.vn",
    location: "Ho Chi Minh City, Vietnam",
    company: "EverRice Company Limited",
  },
  home: {
    hero: {
      eyebrow: "YOUR TRUSTED PARTNER",
      title: "Connecting Vietnamese Rice to the World",
      sub1: "High-quality rice. Sustainable growth.",
      sub2: "A better future for people and communities.",
      cta: "Our Products",
    },
    about: {
      eyebrow: "About EverRice",
      title1: "Rooted in Vietnam",
      title2: "Growing Together Globally",
      desc: "We are a Vietnamese rice exporter committed to delivering premium-quality rice to global markets, while creating sustainable value for farmers, partners and communities.",
      cta: "Learn More",
      features: [
        {
          title: "Premium Quality",
          desc: "Carefully selected from fertile lands",
        },
        { title: "Global Supply", desc: "Trusted by partners worldwide" },
        {
          title: "Sustainable Growth",
          desc: "For people, communities and the environment",
        },
      ],
    },
    products: {
      eyebrow: "Our Products",
      title: "Exceptional Rice\nfor a Better Tomorrow",
      desc: "From exquisite fragrant rice to premium white, glutinous and specialty varieties, we proudly bring the finest Vietnamese rice to tables around the world.",
      cta: "Explore Products",
      items: [
        { name: "FRAGRANT Rice", desc: "Fragrant & delicate" },
        { name: "White Rice", desc: "Consistent quality" },
        { name: "GLUTINOUS", desc: "Nutritious & wholesome" },
        { name: "Specialty Rice", desc: "Unique varieties" },
      ],
    },
    stats: [
      { value: "15+", label: "Export countries" },
      { value: "200k", label: "Tons shipped yearly" },
      { value: "40k", label: "Tons monthly capacity" },
      { value: "14", label: "Years of expertise" },
    ],
    globalReach: {
      eyebrow: "Global Reach",
      title: "From Vietnam to the World",
      desc: "We supply high-quality rice to markets across Asia, North America, Europe, Africa and beyond.",
      cta: "Our Markets",
    },
    sustainability: {
      eyebrow: "Sustainability",
      title: "Nurturing Today\nfor Generations Tomorrow",
      desc: "We work closely with farmers, promote sustainable farming practices and contribute to a greener, healthier future.",
      cta: "Our Commitment",
      features: [
        { title: "Supporting Farmers" },
        { title: "Environmental Responsibility" },
        { title: "Stronger Communities" },
      ],
    },
  },
  aboutPage: {
    hero: {
      eyebrow: "ABOUT EverRice",
      title: "Rooted in Vietnam, Growing Globally",
      desc: "A trusted Vietnamese rice exporter, committed to quality, integrity, and lasting partnerships with farmers and rice importers around the world.",
    },
    story: {
      eyebrow: "Our Story",
      title: "From a Small Rice Exporter to a Trusted Global Partner",
      p1: "EverRice began as a small Vietnamese rice exporter, built on a simple commitment to quality, integrity, and trust. By working closely with farmers and customers, we grew through every shipment and every relationship.",
      p2: "Today, we connect Vietnam’s finest rice with rice importers around the world. While our reach has grown, our values remain the same — building lasting partnerships and delivering quality you can trust.",
      ctaProducts: "Our Products",
      ctaContact: "Contact Us",
    },
    pillars: {
      eyebrow: "What Drives Us",
      title: "Mission, Vision, Values",
      items: [
        {
          title: "Our Mission",
          desc: "To deliver premium Vietnamese Rice to the world while building long-term partnership with famers and rice importers worldwide.",
        },
        {
          title: "Our Vision",
          desc: "To become the most trusted Vietnamese rice partner across global markets, known for quality and integrity.",
        },
        {
          title: "Our Values",
          desc: "Quality First. Sustainable Growth. Integrity. Honest Partnerships. Respect.",
        },
      ],
    },
    values: {
      eyebrow: "Our Core Values",
      title: "Principles That Guide Us",
      items: [
        {
          title: "Quality First",
          desc: "We never compromise on the quality of what we deliver.",
        },
        {
          title: "Sustainable Growth",
          desc: "We build for long-term success, creating value for our partners and the communities we work with.",
        },
        {
          title: "Integrity",
          desc: "We do what is right, keep our promises, and take responsibility for our actions.",
        },
        {
          title: "Honest Partnerships",
          desc: "We believe lasting business relationships are built on transparency, trust, and mutual success.",
        },
        {
          title: "Respect",
          desc: "We value our farmers, partners, customers, and every person who contributes to our journey.",
        },
      ],
    },
    facilities: {
      eyebrow: "Behind Every Grain",
      title: "From Paddy Field to Your Port",
      sub: "A fully traceable chain — sourcing, milling and testing.",
      items: [
        { title: "Sourced from the Mekong Delta" },
        { title: "Processed in modern mills" },
        { title: "Tested by certified labs" },
      ],
    },
    stats: [
      { value: "14", label: "Years of expertise" },
      { value: "15+", label: "Export countries" },
      { value: "40k", label: "Tons monthly capacity" },
      { value: "200k", label: "Tons shipped yearly" },
    ],
  },
  productsPage: {
    hero: {
      eyebrow: "OUR PRODUCTS",
      title: "Exceptional Rice,\nFor a Better Tomorrow",
      desc: "From exquisite fragrant rice to premium white, glutinous and specialty varieties, we proudly bring the finest Vietnamese rice to tables around the world.",
    },
    grid: {
      categories: [
        { key: "all", label: "All Products" },
        { key: "fragrant", label: "Fragrant Rice" },
        { key: "white", label: "White Rice" },
        { key: "brown", label: "GLUTINOUS" },
        { key: "specialty", label: "Specialty Rice" },
      ],
      labels: {
        grade: "Grain length",
        packing: "Packing",
        moisture: "Moisture",
      },
      items: [
        {
          cat: "fragrant",
          name: "Jasmine Rice",
          desc: "Soft, fragrant and naturally sweet — our signature Thai-jasmine style long grain.",
          grade: "Premium 5% broken",
          packaging: "1kg / 5kg / 25kg / 50kg",
          moisture: "14% max",
        },
        {
          cat: "fragrant",
          name: "Fragrant Long Grain",
          desc: "Delicate pandan aroma with a light, fluffy texture that stays tender after cooking.",
          grade: "Premium 5% broken",
          packaging: "5kg / 10kg / 25kg",
          moisture: "14% max",
        },
        {
          cat: "fragrant",
          name: "ST25 Rice",
          desc: "Award-winning premium long grain with a soft, naturally sweet taste and a delicate aroma.",
          grade: "Premium 5% broken",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14% max",
        },
        {
          cat: "fragrant",
          name: "Nàng Hoa Rice",
          desc: "Slender aromatic long grain prized for its gentle floral scent and tender bite.",
          grade: "Premium 5% broken",
          packaging: "5kg / 10kg / 25kg",
          moisture: "14% max",
        },
        {
          cat: "white",
          name: "White Rice 5%",
          desc: "The everyday standard — clean, consistent and ideal for daily meals and catering.",
          grade: "5% broken",
          packaging: "10kg / 25kg / 50kg",
          moisture: "14% max",
        },
        {
          cat: "white",
          name: "White Rice 15%",
          desc: "Reliable value grade for food service, processing and high-volume buyers.",
          grade: "15% broken",
          packaging: "25kg / 50kg",
          moisture: "14% max",
        },
        {
          cat: "white",
          name: "White Rice 10%",
          desc: "A balanced everyday grade — clean, smooth and well milled for daily cooking.",
          grade: "10% broken",
          packaging: "25kg / 50kg",
          moisture: "14% max",
        },
        {
          cat: "white",
          name: "Japanese-Style Rice",
          desc: "Short, round grain with a glossy, sticky finish — ideal for sushi and Japanese cuisine.",
          grade: "Short grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14% max",
        },
        {
          cat: "brown",
          name: "Brown Rice",
          desc: "Whole grain with the bran intact — nutty, wholesome and rich in fibre.",
          grade: "Whole grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14.5% max",
        },
        {
          cat: "brown",
          name: "Red Cargo Rice",
          desc: "Distinctive red bran with a firm bite and a warm, earthy flavour.",
          grade: "Whole grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14.5% max",
        },
        {
          cat: "brown",
          name: "White Glutinous Rice",
          desc: "Glossy, tender and naturally sticky — the classic choice for festive dishes and desserts.",
          grade: "Whole grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14.5% max",
        },
        {
          cat: "brown",
          name: "Pandan Glutinous Rice",
          desc: "Fragrant glutinous rice with a soft green hue and a light pandan aroma.",
          grade: "Whole grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14.5% max",
        },
        {
          cat: "specialty",
          name: "Black Glutinous Rice",
          desc: "Glossy, naturally sweet and sticky — a favourite for traditional desserts.",
          grade: "Whole grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14.5% max",
        },
        {
          cat: "specialty",
          name: "Organic Jasmine",
          desc: "Certified organic, grown without synthetic pesticides for the cleanest table.",
          grade: "Organic certified",
          packaging: "1kg / 5kg",
          moisture: "14% max",
        },
        {
          cat: "specialty",
          name: "Germinated Brown Rice",
          desc: "GABA-rich sprouted brown rice — extra nutrition with a softer, nuttier texture.",
          grade: "Germinated",
          packaging: "1kg / 5kg",
          moisture: "14% max",
        },
        {
          cat: "specialty",
          name: "Red Dragon Rice",
          desc: "Rare deep-red heirloom grain with a rich colour and a firm, wholesome bite.",
          grade: "Whole grain",
          packaging: "1kg / 5kg / 25kg",
          moisture: "14.5% max",
        },
      ],
    },
    certs: {
      eyebrow: "Quality Assurance",
      title: "Certified at Every Step",
      desc: "Every batch is tested for purity, moisture and food safety before it leaves our mills.",
      items: [
        { title: "HACCP", desc: "Food safety management certified" },
        { title: "ISO 22000", desc: "Global food safety standard" },
        { title: "Organic", desc: "Certified organic varieties" },
        { title: "GLOBALG.A.P.", desc: "Responsible farming practices" },
      ],
    },
    packaging: {
      eyebrow: "Flexible Options",
      title: "Packaging for Every Buyer",
      items: [
        {
          title: "Retail Packs",
          desc: "1kg, 2kg and 5kg retail-ready bags for supermarkets and e-commerce.",
        },
        {
          title: "Bulk Bags",
          desc: "25kg and 50kg woven PP or paper sacks for distributors and processors.",
        },
        {
          title: "Container Loads",
          desc: "Full 20ft and 40ft container shipments with flexible FCL and LCL terms.",
        },
      ],
      box: {
        title: "Need a custom specification?",
        desc: "Tell us your grade, volume and destination — we will prepare a tailored quotation.",
        cta: "Request a Quote",
      },
    },
  },
  qualityPage: {
    hero: {
      eyebrow: "QUALITY ASSURANCE",
      title: "Quality You Can Taste in Every Grain",
      desc: "Consistent standards, rigorous testing and full traceability — that is how we earn the trust of buyers in more than 15 countries.",
    },
    intro: {
      eyebrow: "Our Commitment",
      title: "Standards We Stand By",
      desc: "Great rice is not an accident. It comes from carefully selected paddy, precise milling and honesty at every checkpoint. Our team inspects each lot so that what leaves our mills is exactly what our partners expect — batch after batch.",
      highlights: [
        {
          title: "Lab-Tested Every Batch",
          desc: "Each lot is sampled and analysed for moisture, purity and broken grains before approval.",
        },
        {
          title: "Full Traceability",
          desc: "From the paddy field to the container number — every step is recorded and verifiable.",
        },
        {
          title: "Certified Standards",
          desc: "Operations aligned with HACCP, ISO 22000 and GLOBALG.A.P. food safety frameworks.",
        },
      ],
    },
    process: {
      eyebrow: "Our Process",
      title: "Five Checkpoints. One Commitment to Quality.",
      items: [
        {
          step: "01",
          title: "Field Selection",
          desc: "We select paddy from partner farms in certified growing regions, traceable to the plot level.",
        },
        {
          step: "02",
          title: "Controlled Milling",
          desc: "Modern mills with calibrated hulling and polishing to reach a consistent milling degree.",
        },
        {
          step: "03",
          title: "Laboratory Testing",
          desc: "Samples are checked for moisture, broken grains, foreign matter and food safety markers.",
        },
        {
          step: "04",
          title: "Precision Packing",
          desc: "Clean, food-grade packaging under controlled conditions, sealed and labelled per order.",
        },
        {
          step: "05",
          title: "Documented Shipping",
          desc: "Certificates of quality and analysis accompany every shipment, ensuring full transparency.",
        },
      ],
    },
    specs: {
      eyebrow: "Technical Standards",
      title: "What We Measure",
      sub: "Typical export specifications. Final parameters are agreed with each buyer per contract.",
      head: { param: "Parameter", standard: "Standard", method: "Test Method" },
      rows: [
        { param: "Moisture Content", standard: "14.0% max", method: "ISO 712" },
        {
          param: "Broken Grains",
          standard: "5% / 15% by grade",
          method: "ISO 7301",
        },
        {
          param: "Foreign Matter",
          standard: "0.10% max",
          method: "Visual & sieving",
        },
        {
          param: "Paddy Grains",
          standard: "5 grains / kg max",
          method: "Manual count",
        },
        {
          param: "Milling Degree",
          standard: "Well milled",
          method: "Visual assessment",
        },
        {
          param: "Whiteness Index",
          standard: "40+",
          method: "Whiteness meter",
        },
      ],
    },
    labs: {
      eyebrow: "Behind the Scenes",
      title: "Where Quality Happens",
      items: [
        { title: "Grain Inspection" },
        { title: "Testing Laboratory" },
        { title: "Controlled Storage" },
      ],
    },
    certs: {
      eyebrow: "Recognised Worldwide",
      title: "Certified at Every Step",
      desc: "Independent audits and recognised certifications back up the standards we promise to our partners.",
      items: [
        { title: "HACCP", desc: "Hazard analysis and critical control points" },
        { title: "ISO 22000", desc: "Global food safety management" },
        { title: "Organic", desc: "Certified organic varieties" },
        { title: "GLOBALG.A.P.", desc: "Responsible farming practices" },
      ],
    },
    stats: [
      { value: "100%", label: "Batches lab-tested" },
      { value: "24h", label: "Average test turnaround" },
      { value: "0.1%", label: "Max foreign matter" },
      { value: "5", label: "Quality checkpoints" },
    ],
    cta: {
      title: "Request our quality documentation",
      desc: "Specifications, certificates of analysis and inspection reports are available for every order. Tell us your requirements and we will prepare the details.",
      ctaContact: "Get in Touch",
      ctaProducts: "Our Products",
    },
  },
  sustainabilityPage: {
    hero: {
      eyebrow: "SUSTAINABILITY",
      title: "Growing Responsibly, Harvesting the Future",
      desc: "We believe great rice should never cost the earth. Every harvest is an opportunity to care for the land, the farmers and the communities behind it.",
    },
    intro: {
      eyebrow: "Our Philosophy",
      title: "Nurturing Today for Generations Tomorrow",
      p1: "We work side by side with the growers who tend the paddies, sharing knowledge and investing in practices that protect the soil, save water and secure their livelihoods.",
      p2: "From the field to the mill, we reduce waste, use cleaner energy and keep our supply chain transparent, so that every bag of rice carries a lighter footprint and a fairer story.",
      ctaQuality: "Our Quality",
      ctaWork: "Work With Us",
    },
    pillars: {
      eyebrow: "What We Stand For",
      title: "Three Pillars of Our Commitment",
      items: [
        {
          title: "Supporting Farmers",
          desc: "Fair pricing, long-term contracts and training that help partner families grow with confidence.",
        },
        {
          title: "Environmental Responsibility",
          desc: "Water-saving irrigation, organic practices and renewable energy across our mills.",
        },
        {
          title: "Stronger Communities",
          desc: "Investing in local schools, clean water and opportunities where our rice is grown.",
        },
      ],
    },
    initiatives: {
      eyebrow: "In Action",
      title: "Initiatives Across the Supply Chain",
      sub: "Concrete programmes that make our rice better for people and the planet.",
      items: [
        {
          title: "Water-Saving Irrigation",
          desc: "Alternate wetting and drying techniques that cut water use while keeping yields strong.",
        },
        {
          title: "Organic Practices",
          desc: "Reduced chemical inputs and natural soil care for healthier, cleaner paddies.",
        },
        {
          title: "Fair Trade Pricing",
          desc: "Transparent contracts that give farmers a stable and fair income for their harvest.",
        },
        {
          title: "Farmer Training",
          desc: "Field schools teaching modern, sustainable techniques to partner growers.",
        },
        {
          title: "Renewable Energy",
          desc: "Solar and biomass power reducing the carbon footprint of our milling operations.",
        },
        {
          title: "Reduced Waste",
          desc: "Rice husks and bran reused as biomass fuel and animal feed instead of waste.",
        },
      ],
    },
    goals: {
      eyebrow: "Our 2030 Targets",
      title: "Where We Are Heading",
      items: [
        {
          value: "100%",
          label: "Responsibly sourced rice",
          desc: "All rice sourced from certified sustainable growers by 2030.",
        },
        {
          value: "30%",
          label: "Less water used",
          desc: "Reduce irrigation water per ton of paddy across partner farms.",
        },
        {
          value: "50%",
          label: "Renewable energy",
          desc: "Half of milling energy from solar and biomass sources.",
        },
        {
          value: "20,000",
          label: "Farmers trained",
          desc: "Expand our sustainable farming education programme.",
        },
      ],
    },
    stats: [
      { value: "12,000", label: "Partner farmers supported" },
      { value: "4,500 ha", label: "Sustainably farmed land" },
      { value: "30%", label: "Water saved per harvest" },
      { value: "18", label: "Years growing together" },
    ],
    cta: {
      title: "Grow something better with us",
      desc: "Partner with a rice exporter that cares about quality, people and the planet. Let us build a more responsible supply chain together.",
      ctaContact: "Get in Touch",
      ctaProducts: "Our Products",
    },
  },
  globalReachPage: {
    hero: {
      eyebrow: "GLOBAL REACH",
      title: "From Vietnam to the World",
      desc: "We supply high-quality rice to markets across Asia, North America, Europe, Africa and beyond.",
      cta: "Our Markets",
      stats: [
        { value: "30+", label: "Countries & Regions" },
        { value: "100+", label: "Trusted Partners" },
        { value: "1M+", label: "Tons Supplied Annually" },
      ],
    },
    overview: {
      eyebrow: "Our Network",
      title: "One Supply Chain, Many Markets",
      p1: "EverRice connects the fertile rice paddies of the Mekong Delta with importers, distributors and retailers around the globe. Over two decades we have built long-term relationships that turn a single order into a dependable partnership.",
      p2: "From export documentation and quality certificates to tailored packaging and shipping schedules, our team handles the details so your shelves stay stocked — season after season.",
      ctaProducts: "Our Products",
      ctaQuote: "Request a Quote",
      stats: [
        { value: "25+", label: "Export markets" },
        { value: "200k", label: "Tons shipped yearly" },
        { value: "5", label: "Continents served" },
        { value: "24h", label: "Quote response time" },
      ],
    },
    map: {
      eyebrow: "Export Markets",
      title: "Where Our Rice Travels",
      labels: {
        markets: "Markets",
        ofVolume: "Of volume",
        growth: "Growth",
        keyMarkets: "Key markets",
        viewAria: "View export data",
      },
      countries: {
        spain: "Spain",
        austria: "Austria",
        dubai: "Dubai",
        ghana: "Ghana",
        russia: "Russia",
        canada: "Canada",
        usa: "USA",
        china: "China",
        hongkong: "Hong Kong",
        philippines: "Philippines",
        malaysia: "Malaysia",
        singapore: "Singapore",
        indonesia: "Indonesia",
        australia: "Australia",
        solomon: "Solomon",
      },
      regions: [
        {
          name: "Asia",
          tagline: "Our largest and longest-standing market",
          desc: "From Tokyo to Manila, our fragrant and white rice is a trusted staple across Asian dining tables — supplied year-round under long-term contracts.",
          growth: "+12% YoY",
          volume: "190,000 MT",
          markets: [
            "Japan",
            "Philippines",
            "China",
            "South Korea",
            "Singapore",
            "Malaysia",
          ],
        },
        {
          name: "Middle East",
          tagline: "A fast-growing partner region",
          desc: "We serve hotels, retailers and distributors across the Gulf with consistent, well-milled rice tailored to regional taste and Halal requirements.",
          growth: "+18% YoY",
          volume: "130,000 MT",
          markets: [
            "United Arab Emirates",
            "Saudi Arabia",
            "Qatar",
            "Kuwait",
            "Oman",
          ],
        },
        {
          name: "Europe",
          tagline: "Premium quality for discerning buyers",
          desc: "European importers rely on our traceable supply chain, stringent quality control and reliable documentation for every container we ship.",
          growth: "+9% YoY",
          volume: "95,000 MT",
          markets: [
            "Germany",
            "Netherlands",
            "Poland",
            "United Kingdom",
            "France",
          ],
        },
        {
          name: "Africa",
          tagline: "Building food security together",
          desc: "We support wholesalers and relief programmes across West and Southern Africa with dependable volumes and flexible packaging options.",
          growth: "+15% YoY",
          volume: "55,000 MT",
          markets: ["Ghana", "Ivory Coast", "South Africa"],
        },
        {
          name: "Americas",
          tagline: "Expanding into new shores",
          desc: "A newer frontier for EverRice, serving Asian-food retailers and distributors across North America with authentic Vietnamese varieties.",
          growth: "+21% YoY",
          volume: "30,000 MT",
          markets: ["United States", "Canada"],
        },
      ],
    },
    regionStats: {
      eyebrow: "By The Numbers",
      title: "Our Scale and Capability",
      sub: "Indicative annual volumes across our five destination regions.",
      marketsUnit: "destination markets",
      shareUnit: "of total exports",
    },
    keyMarkets: {
      eyebrow: "Key Destinations",
      title: "Trusted by Buyers Worldwide",
      items: [
        {
          country: "Philippines",
          region: "Asia",
          note: "High-volume buyers of fragrant and white rice. Container and breakbulk vessel loading options.",
        },
        {
          country: "China",
          region: "Asia",
          note: "High-volume buyers of fragrant and glutinous rice. Primarily supplied by container loading.",
        },
        {
          country: "Singapore",
          region: "Asia",
          note: "Regional trading hub for food distribution, wholesale, and foodservice.",
        },
        {
          country: "Hong Kong",
          region: "Asia",
          note: "Premium market for fragrant and sushi-grade rice.",
        },
      ],
    },
    logistics: {
      eyebrow: "From Paddy field to Port",
      title: "Optimizing Logistics, Simplifying Processes",
      items: [
        {
          title: "Sourcing & Milling",
          desc: "Paddy sourced from partner farms and milled in our modern, quality-controlled facilities.",
        },
        {
          title: "Quality Inspection",
          desc: "Every lot lab-tested for moisture, broken grains and purity before it is approved.",
        },
        {
          title: "Packaging & Loading",
          desc: "Bags or bulk containers packed and palletised to your exact specification.",
        },
        {
          title: "Sea Freight",
          desc: "Shipped through Vietnam’s major ports with full export documentation handled.",
        },
        {
          title: "Delivery & Support",
          desc: "On-time arrival at your port of choice, with a dedicated account manager.",
        },
      ],
    },
    compliance: {
      eyebrow: "Export Ready",
      title: "Documentation & Compliance, Handled",
      desc: "From export documentation and quality certificates to tailored packaging and shipping schedules, our team handles the details so your shipment clears without any delays.",
      items: [
        {
          title: "HACCP & ISO 22000",
          desc: "Food-safety management across our entire milling operation.",
        },
        {
          title: "Phytosanitary Certificate",
          desc: "Official plant-health papers issued for every export shipment.",
        },
        {
          title: "Certificate of Origin",
          desc: "Full documentation confirming Vietnamese origin for customs.",
        },
        {
          title: "Halal & Kosher Options",
          desc: "Certified handling available for Middle East and other buyers.",
        },
      ],
    },
    cta: {
      title: "Let’s ship to your market",
      desc: "Tell us your destination port, volume and packaging needs — our export team will get back to you with a tailored quotation within one business day.",
      ctaContact: "Contact Sales",
      ctaQuality: "Our Quality",
    },
  },
  contactPage: {
    hero: {
      eyebrow: "CONTACT US",
      title: "Let’s Talk",
      desc: "Whether you need a quotation, a product sample or a long-term supply partner, our export team is ready to help.",
    },
    main: {
      eyebrow: "Get in Touch",
      title: "We’d Love to Hear From You",
      desc: "Reach out through the form or the details below. Our export specialists respond to every enquiry within one business day.",
      info: [
        {
          label: "Visit Us",
          value:
            "The Everrich, 968 3/2 Street, Phu Tho Ward, Ho Chi Minh City, Vietnam",
        },
        { label: "Email Us", value: "info@everrice.vn" },
        { label: "Call Us", value: "+84 918335899" },
        {
          label: "Working Hours",
          value: "Monday – Saturday, 8:00 – 17:00 (GMT+7)",
        },
      ],
      ctaProducts: "Browse Products",
      ctaReach: "Global Reach",
    },
    form: {
      title: "Send Us a Message",
      note: "Fields marked with * are required.",
      name: "Name",
      namePh: "Your full name",
      email: "Email",
      emailPh: "you@company.com",
      phone: "Phone",
      phonePh: "+84 ...",
      message: "Message",
      messagePh:
        "Tell us your destination market, volume and packaging needs...",
      submit: "Send Message",
      sending: "Sending...",
      success:
        "Thank you! Your message has been sent — we will get back to you shortly.",
      errorDefault: "We could not send your message. Please try again.",
      network:
        "A network error occurred. Please check your connection and try again.",
      extraLabel: "Extra detail",
    },
    map: {
      eyebrow: "Find Us",
      title: "Welcome to EverRice",
    },
  },
};
